// Module
var code = "<div flex class=\"app-building full-height\" layout=\"row\"> <div flex class=\"building-content\" layout=\"column\" ui-view></div> </div> ";
// Exports
module.exports = code;